import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useStyles } from './IconCard.styles';
export const IconCard = (props) => {
    const classes = useStyles();
    let styles;
    if (props.disabled) {
        styles = [classes.icon, classes.disabledIcon];
    }
    else {
        styles = [classes.icon];
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { component: "div", sx: styles }, props.icon),
        React.createElement(Box, { component: "div", sx: classes.textContent },
            React.createElement(Typography, { variant: "h4", sx: classes.title }, props.title))));
};
export default IconCard;
